import { render, staticRenderFns } from "./SkuInventory.vue?vue&type=template&id=5fab312e"
import script from "./SkuInventory.vue?vue&type=script&lang=js"
export * from "./SkuInventory.vue?vue&type=script&lang=js"
import style0 from "./SkuInventory.vue?vue&type=style&index=0&id=5fab312e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports